import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { LinkButton } from './Button';
const navItems = [{
  label: 'Services',
  to: '/services'
}, {
  label: 'Our approach',
  to: '/approach'
}, {
  label: 'Locations',
  to: '/locations'
}, {
  label: 'Insights',
  to: '/insights'
}, {
  label: 'About',
  to: '/about'
}];
export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className={['sticky top-0 z-50 transition-[background-color,border-color,box-shadow] duration-200 ease-out-quint', scrolled || open ? 'border-b border-line bg-cream/95 backdrop-blur-sm' : 'border-b border-transparent bg-cream'].join(' ')} data-id="element-196" data-mp="2bch9da4xroi3">
      <div className="mx-auto flex h-16 w-full max-w-shell items-center justify-between gap-6 px-5 sm:h-[4.5rem] sm:px-8" data-id="element-197" data-mp="2ji9g63hvkjho">
        <Link to="/" className="flex items-baseline gap-[0.15rem]" aria-label="MeraBucket home" data-id="element-198" data-mp="2og1i7qc8hlzl">
          <span className="font-serif text-[1.35rem] tracking-tight text-charcoal" data-id="element-199" data-mp="1qu3w7iynayiw">Mera</span>
          <span className="font-serif text-[1.35rem] tracking-tight text-gold" data-id="element-200" data-mp="1vrm6pdsb9lt0">Bucket</span>
        </Link>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary" data-id="element-201" data-mp="20qgxb1wiseno">
          {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
          isActive
        }) => ['relative py-1 text-sm font-medium transition-colors duration-200 ease-out-quint', isActive ? 'text-charcoal' : 'text-charcoal-600 hover:text-charcoal'].join(' ')} data-id="element-202" data-mp="25jrvyfr6hp4i">
              {({
            isActive
          }) => <>
                  {item.label}
                  <span aria-hidden="true" className={['absolute -bottom-0.5 left-0 h-px w-full bg-gold transition-opacity duration-200 ease-out-quint', isActive ? 'opacity-100' : 'opacity-0'].join(' ')} data-id="element-203" data-mp="1erb0kkrnr21q" />
                </>}
            </NavLink>)}
        </nav>

        <div className="flex items-center gap-2" data-id="element-204" data-mp="w1bco17jzszw">
          <LinkButton to="/contact" className="hidden sm:inline-flex" data-id="element-205" data-mp="r1gkzvfyezds">
            Book a consultation
          </LinkButton>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="flex h-10 w-10 items-center justify-center rounded-sm text-charcoal transition-colors duration-200 ease-out-quint hover:bg-charcoal/[0.05] lg:hidden" data-id="element-206" data-mp="27f70dycixa2q">
            {open ? <XIcon className="h-5 w-5" data-id="element-207" data-mp="210i02zhnm0im" /> : <MenuIcon className="h-5 w-5" data-id="element-208" data-mp="2119o9p8x8vyv" />}
          </button>
        </div>
      </div>

      {open ? <div id="mobile-nav" className="border-t border-line bg-cream lg:hidden" data-id="element-209" data-mp="2534m2jrn8r7w">
          <nav className="mx-auto flex max-w-shell flex-col px-5 py-2 sm:px-8" aria-label="Mobile" data-id="element-210" data-mp="2sr5xq1k4cnrj">
            {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
          isActive
        }) => ['border-b border-line/70 py-3.5 font-serif text-lg last:border-0', isActive ? 'text-gold-dark' : 'text-charcoal'].join(' ')} data-id="element-211" data-mp="2jykj8xnit38i">
                {item.label}
              </NavLink>)}
            <LinkButton to="/contact" size="lg" className="my-4 sm:hidden" data-id="element-212" data-mp="1ssx0zc5t5ys9">
              Book a consultation
            </LinkButton>
          </nav>
        </div> : null}
    </header>;
}